
document.addEventListener("DOMContentLoaded", function() {
const carousel = document.querySelector(".product__essentials-carousel");
const prevButton = document.getElementById("prev-button");
const nextButton = document.getElementById("next-button");
const images = carousel.querySelectorAll("img");
const videos = carousel.querySelectorAll("deferred-media");
const footerItems = document.querySelectorAll(".product__essentials-carousel-footer__image");

const zoomImage = document.getElementsByClassName('currentSlide');

let currentIndex = 0;

function showImage(index) {
    images.forEach(function(image) {
    image.style.display = "none";
    });
    images[index].style.display = "block";

    videos.forEach(function(video) {
        video.style.display = "none";
    });
  if(videos.length > 0) {
   videos[index].style.display = "block"; 
  }
}

function prevImage() {
    currentIndex = (currentIndex - 1 + images.length) % images.length;
    showImage(currentIndex);
}

function nextImage() {
    currentIndex = (currentIndex + 1) % images.length;
    showImage(currentIndex);
}

function changeImage(event) {
    const index = event.target.getAttribute("data-change");
    if (!isNaN(index)) {
        currentIndex = index;
        showImage(currentIndex);
    }
}

prevButton.addEventListener("click", prevImage);
nextButton.addEventListener("click", nextImage);

footerItems.forEach(function(item) {
  item.addEventListener("click", changeImage);
});

for (let i = 0; i < zoomImage.length; i++) {
    zoomImage[i].addEventListener('click', function() {
        this.classList.toggle('enlarged');
    });
};

showImage(currentIndex);
});
